module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"parameterHeader":"Parameter","startYearLabel":"Startjahr","endYearLabel":"Endjahr","interestRate":"Zinssatz","usageTypesStandard":"Nutzungsdatennorm"}}')
  delete Component.options._Ctor
}
